import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "quickpay-faq" }
const _hoisted_2 = { class: "quickpay-faq__header" }
const _hoisted_3 = { class: "typographies-paragraph-large-bold" }
const _hoisted_4 = { class: "quickpay-faq__answer typographies-paragraph-medium-regular" }

import { computed, inject } from 'vue';
import { Translator } from 'types/injects/translator.type';
import {
    type TranslationPart,
    useTranslationLinkParser,
} from 'composables/useTranslationLinkParser';

import TranslationText from 'vcomponents/common/TranslationText.vue';

interface FaqItem {
    questionKey: string;
    answerKey: string;
}

interface Props {
    items: FaqItem[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'QuickpaySettingsFaq',
  props: {
    items: {}
  },
  setup(__props: any) {

const props = __props;

const $t = inject('$t') as Translator;

const { parseTranslation } = useTranslationLinkParser();

const translations = {
    faqTitle: $t.__('quickpay.settings.setupModal.common.faqTitle'),
};

const translatedItems = computed((): { question: string; answerParts: TranslationPart[] }[] =>
    props.items.map((item) => ({
        question: $t.__(item.questionKey),
        answerParts: parseTranslation($t.__(item.answerKey)),
    })),
);

return (_ctx: any,_cache: any) => {
  const _component_CompassColoredIcon = _resolveComponent("CompassColoredIcon")!
  const _component_CompassAccordion = _resolveComponent("CompassAccordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CompassColoredIcon, {
        icon: "help-circle",
        color: _ctx.CompassEnums.ColoredIconColorType.LIGHT_BLUE
      }, null, 8 /* PROPS */, ["color"]),
      _createElementVNode("span", _hoisted_3, _toDisplayString(translations.faqTitle), 1 /* TEXT */)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(translatedItems.value, (item, index) => {
      return (_openBlock(), _createBlock(_component_CompassAccordion, {
        key: index,
        class: "quickpay-faq__accordion",
        title: item.question,
        variant: _ctx.CompassEnums.AccordionVariantType.H4
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_4, [
            _createVNode(TranslationText, {
              parts: item.answerParts
            }, null, 8 /* PROPS */, ["parts"])
          ])
        ]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title", "variant"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

})